import { useState, useEffect } from 'react';
import { Box, Card, Chip, Tab, Tabs, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PanelAcuAgentes from './components/PanelAcuAgentes';
import PanelDetalleLlamadas from './components/PanelDetalleLlamadas';
import MitrolReportesService from '../../services/mitrolReportes.service';

const MitrolReportesScreen = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const [tabIndex, setTabIndex] = useState(0);
  const [healthStatus, setHealthStatus] = useState('Verificando...');
  const [healthColor, setHealthColor] = useState('default');

  useEffect(() => {
    const checkHealth = async () => {
      try {
        await MitrolReportesService.healthCheck();
        setHealthStatus('Conectado');
        setHealthColor('success');
      } catch {
        setHealthStatus('Desconectado');
        setHealthColor('error');
      }
    };
    checkHealth();
  }, []);

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  const tabLabels = [
    { label: 'Acumuladores de Agentes', method: 'POST' },
    { label: 'Detalle Interacciones', method: 'POST' },
  ];

  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2, md: 3 },
        maxWidth: 1400,
        margin: '0 auto',
        height: 'calc(100vh - 64px)',
        overflow: 'auto',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          mb: 3,
        }}
      >
        <Typography variant="h5" fontWeight={600}>
          Mitrol Reports
        </Typography>
        <Chip
          label={healthStatus}
          size="small"
          color={healthColor}
          sx={{ fontWeight: 600, fontSize: '0.7rem' }}
        />
      </Box>

      {/* Tabs */}
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        sx={{
          mb: 2,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontSize: '0.85rem',
            minHeight: 44,
          },
        }}
      >
        {tabLabels.map((tab, i) => (
          <Tab
            key={i}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Chip
                  label={tab.method}
                  size="small"
                  color="primary"
                  sx={{
                    height: 18,
                    fontSize: '0.6rem',
                    fontWeight: 700,
                    '& .MuiChip-label': { px: 0.8 },
                  }}
                />
                <span>{tab.label}</span>
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Panel Content */}
      <Card
        variant="outlined"
        sx={{
          p: { xs: 2, sm: 3 },
          bgcolor: isDarkMode ? '#1e293b' : '#fff',
        }}
      >
        {tabIndex === 0 && <PanelAcuAgentes />}
        {tabIndex === 1 && <PanelDetalleLlamadas />}
      </Card>
    </Box>
  );
};

export default MitrolReportesScreen;
